<template>
  <div class="enrolling-log">
    <div class="header">
      <span class="title">学生信息日志</span>
      <span v-if="rowData.trueName">-【{{rowData.trueName}}】</span>
    </div>
    <div class="main">
      <div class="enrolling-log-cont"
           v-loading="loading"
           element-loading-text="页面加载中，请稍等...">
        <el-tabs v-model="currentLogType" tab-position="right" v-if="logTypes && logTypes.length > 0">
          <el-tab-pane v-for="logType in logTypes"
                       :key="logType.code"
                       :label="logType.name"
                       :name="logType.code"
                       lazy>
            <EnrollingLogItem :row-data="rowData"
                             :log-type="logType"/>
          </el-tab-pane>
        </el-tabs>
        <Hint v-else
              v-show="!loading">
          <span v-if="logTypes">没有可查看的日志类型</span>
          <span v-else>{{errorMsg}}</span>
        </Hint>
      </div>
    </div>
  </div>
</template>
<script>
import EnrollingLogItem from './item/index'
import Hint from '../../../../../elements/Hint'
export default {
  name: 'EnrollingLog',
  components: {EnrollingLogItem, Hint},
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      logTypes: null,
      errorMsg: null,
      currentLogType: ''
    }
  },
  methods: {
    loadLogTypes () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/query/logTypes',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.logTypes = response.data['logTypes'] || {}
          this.handleLogType()
        }
      }, () => {
        this.errorMsg = '请求日志类型失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleLogType () {
      if (this.logTypes && this.logTypes.length > 0) {
        this.currentLogType = this.logTypes[0].code
      }
    }
  },
  mounted () {
    return this.loadLogTypes()
  }
}
</script>
<style lang="scss">
.enrolling-log {
  position: relative;
  width: 760px;
  max-width: 100%;
  height: 100%;
  & > .header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 40px;
    background-color: #fff;
    line-height: 38px;
    border-bottom: 1px solid rgba(0,0,0,.05);
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }
  & > .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 40px;
    bottom: 0;
    background-color: #fdfdfd;
    & > .enrolling-log-cont {
      position: relative;
      height: 100%;
      .el-tabs {
        &.el-tabs--right {
          height: 100%;
          & > .el-tabs__header {
            margin-left: 0;
            & > .el-tabs__nav-wrap {
              & > .el-tabs__nav-scroll {
                & > .el-tabs__nav {
                  & > .el-tabs__item {
                    height: 36px;
                    font-size: 13px;
                    line-height: 36px;
                  }
                }
              }
            }
          }
          & > .el-tabs__content {
            height: 100%;
            & > .el-tab-pane {
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
